
import PlaceCategoryMixins2 from "@/mixins/place-category2";
import { mapState } from "vuex";

export default PlaceCategoryMixins2.extend({
  mixins: [PlaceCategoryMixins2],
  name: "component-place-category-genre-btn",
  props: {
    dataName: String,
    iconName: { type: String, required: false },
    displayText: String,
    iconSrc: { type: String, required: false },
    showMask: Boolean,
  },
  computed: {
    ...mapState("data", ["selectedGenre"]),
    isSvg(): boolean {
      return this.iconSrc.includes(".svg");
    },
    selectedPlaceCategory(): string {
      return this.selectedGenre !== undefined ? this.selectedGenre : "";
    },
    systemLocaleEn(): boolean {
      return this.$i18n.locale.includes("en");
    },
    selectedMaskShown(): boolean {
      return this.showMask || this.selectedPlaceCategory === this.dataName;
    },
  },
  methods: {
    rowClicked() {
      this.$emit("genre-btn-clicked", this.dataName);
    },
  },
});
